import { NudosButton, NudosTextArea } from 'components/NudosComponents';
import { Controller, useFormContext } from 'react-hook-form';
import { ILogisticServiceEditionForm } from 'views/LogisticServices/LogisticServiceEdition/LogisticServiceEdition.types';
import './CommentEditPriceModalContent.scss';

interface ICommentEditPriceModalContentProps {
  isSaving: boolean;
}

const CommentEditPriceModalContent = ({ isSaving }: ICommentEditPriceModalContentProps) => {
  const { control } = useFormContext<ILogisticServiceEditionForm>();

  return (
    <Controller
      name="reason"
      control={control}
      render={({ field }) => (
        <article className="commentsModal">
          <p className="subtitle">
            <strong>Explica el motivo por el cual se editaron los precios</strong>
          </p>
          <section className="reasonInputContainer">
            <NudosTextArea
              label="Comentarios sobre la edición*"
              placeholder="Escribe una explicación"
              currentValue={field.value || ''}
              setCurrentValue={field.onChange}
              maxLength={99999}
              customClassName="reasonInput"
              textHeight={64}
              hidenCounter
              noResize
            />
          </section>
          <NudosButton
            buttonText="Guardar cambios"
            componentSize="small"
            isButtonDisabled={!field.value}
            customClassName="sumbitInput"
            isButtonLoading={isSaving}
          />
        </article>
      )}
    />
  );
};

export default CommentEditPriceModalContent;
